import { Trans, useTranslation } from "react-i18next";

const Error500 = () => {
  const { t } = useTranslation();


  return (
    <>
      <h1 className='fw-bolder fs-3 text-gray-700 mb-10'>{t('SystemError')}</h1>
       <div className='fw-bold fs-5 text-gray-400 mb-15'>
        <Trans i18nKey="SystemErrorText" components={{ br: <br/> }} />
       </div>
    </>
  );
};

export default Error500;
